import { doc, deleteDoc } from "firebase/firestore";
import { db } from "../index";

export default async function deleteDiscount(storeId, discountCode) {
    await deleteDoc(doc(db, "Stores", storeId, "Discounts", discountCode))
};